import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();

    const changeLanguage = (language) => {
        i18n.changeLanguage(language);
    };

    return (
        <div className="language-flags">
            <button 
                className={`lang-btn  ${i18n.language === 'bg' ? 'active' : 'opacity-50'}`}
                onClick={() => changeLanguage('bg')}
                title="Смени на български"
            >
                <span className="fi fi-bg"></span>
            </button>
            <button 
                className={`lang-btn  ${i18n.language === 'en' ? 'active' : 'opacity-50'}`}
                onClick={() => changeLanguage('en')}
                title="Switch to English"
            >
                <span className="fi fi-gb"></span>
            </button>
        </div>
    );
};

export default LanguageSwitcher;